module.exports = __webpack_public_path__ + "img/Greenland.97b33d0f.png";